import * as setup from "../constants/setup";
import * as license from "../constants/license";
import * as actionTypes from "../constants/actionTypes";
import * as resources from "../constants/resources";
import * as modelHelper from "../helpers/modelHelper";
import * as getterHelper from "../helpers/getterHelper";

const initialSteps = modelHelper.buildSetupSteps();

const initialState = {
    active: initialSteps[0],
    steps: initialSteps
};

/**
 * Structure of setup store:
 * - active {Object}
 * - steps {Array}
 */
export const setupReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SETUP_NEXT:
            if (state.active.stepNumber < state.active.numberOfSteps) {
                return {
                    ...state,
                    active: state.active.nextStep()
                };
            }

            let nextStep = null;
            let next = false;

            let step;
            for (step of state.steps) {
                if (next && step.available) {
                    nextStep = step;
                    next = false;
                }

                if (state.active.name === step.name) {
                    next = true;
                }
            }

            if (nextStep === null) {
                return state;
            }

            if (nextStep.visited) {
                return {
                    ...state,
                    active: nextStep
                };
            }

            let nextSteps = state.steps.map((step) => {
                if (step.index === nextStep.index) {
                    return step.updateVisited(true);
                }

                return step;
            });

            return {
                ...state,
                active: nextStep.updateVisited(true),
                steps: nextSteps
            };
        case actionTypes.SETUP_SKIP:
            let skipStep = null;
            let isNext = false;

            let s;
            for (s of state.steps) {
                if (isNext && s.available) {
                    skipStep = s;
                    isNext = false;
                }

                if (state.active.name === s.name) {
                    isNext = true;
                }
            }

            if (skipStep === null) {
                return state;
            }

            if (skipStep.visited) {
                return {
                    ...state,
                    active: skipStep
                };
            }

            let newSetupItems = state.steps.map((step) => {
                if (step.index === skipStep.index) {
                    return step.updateVisited(true);
                }

                return step;
            });

            return {
                ...state,
                active: skipStep.updateVisited(true),
                steps: newSetupItems
            };
        case actionTypes.SETUP_BACK:
            if (state.active.stepNumber > 1) {
                return {
                    ...state,
                    active: state.active.previousStep()
                };
            }

            let activeStep = null;
            let previousStep = null;

            let setupStep;
            for (setupStep of state.steps) {
                if (state.active.name === setupStep.name) {
                    activeStep = previousStep;
                }

                if (setupStep.available) {
                    previousStep = setupStep;
                }
            }

            if (activeStep === null) {
                return state;
            }

            return {
                ...state,
                active: activeStep
            };
        case actionTypes.SERVER_IS_LICENSED:
            let newSteps;
            if (action.payload.product === license.PRODUCT_PRICING) {
                newSteps = [];

                let index = 1;
                let pricingStep;
                for (pricingStep of state.steps) {
                    if (pricingStep.name !== setup.MACHINE) {
                        newSteps.push(pricingStep.updateIndex(index));
                        index++;
                    }
                }
            } else {
                newSteps = state.steps;
            }

            let updatedSteps = newSteps.map((step) => {
                if (step.name === setup.LICENSING) {
                    return step.updateCompleted();
                }

                if (step.name === setup.DATABASE) {
                    return step.updateAvailable(true);
                }

                return step;
            });

            return {
                active: getterHelper.getObjectByName(updatedSteps, state.active.name),
                steps: updatedSteps
            };
        case actionTypes.SERVER_COMPATIBLE:
            let updatedDatabaseSteps = state.steps.map((step) => {
                if (step.name === setup.DATABASE) {
                    return step.updateCompleted();
                }

                if (step.name === setup.LOGIN) {
                    return step.updateAvailable(true);
                }

                return step;
            });

            return {
                active: getterHelper.getObjectByName(updatedDatabaseSteps, state.active.name),
                steps: updatedDatabaseSteps
            };
        case actionTypes.SETUP_UPDATE_PRIVILEGES:
            let removeVisited = false;

            let updatedSettingsSteps = state.steps.map((step) => {
                if (step.name === setup.LOGIN) {
                    return step.updateCompleted();
                }

                if (step.name === setup.MACHINE) {
                    if (action.payload.loggedUser.canEdit(resources.SETUP_MACHINE)) {
                        removeVisited = true;

                        let machineStep = step.updateCompleted();
                        machineStep.numberOfSteps = 0;

                        if (action.payload.loggedUser.canEdit(resources.SETUP_MACHINE_DRIVER)) {
                            machineStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_MACHINE_SETTINGS)) {
                            machineStep.increaseNumberOfSteps();
                        }

                        return machineStep;
                    } else {
                        return step.updateAvailable(false);
                    }
                }

                if (step.name === setup.PRINTER) {
                    if (action.payload.loggedUser.canEdit(resources.SETUP_PRINTER)) {
                        removeVisited = true;

                        let printerStep = step.updateCompleted();
                        printerStep.numberOfSteps = 0;

                        if (action.payload.loggedUser.canEdit(resources.SETUP_PRINTER_SETTINGS)) {
                            printerStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_PRINTER_TEMPLATE_SETTINGS)) {
                            printerStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_PRINTER_OPTIONS)) {
                            printerStep.increaseNumberOfSteps();
                        }

                        return printerStep;
                    } else {
                        return step.updateAvailable(false);
                    }
                }

                if (step.name === setup.SPECTRO) {
                    if (action.payload.loggedUser.canEdit(resources.SETUP_SPECTRO)) {
                        removeVisited = true;
                        return step.updateCompleted();
                    } else {
                        return step.updateAvailable(false);
                    }
                }

                if (step.name === setup.SETTINGS) {
                    if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT)) {
                        removeVisited = true;

                        let settingsStep = step.updateCompleted();
                        settingsStep.numberOfSteps = 0;

                        if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT_LAYOUT)) {
                            settingsStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT_NAVIGATION)) {
                            settingsStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT_FORMULA)) {
                            settingsStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT_FORMULA_DATA)) {
                            settingsStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT_UPDATE)) {
                            settingsStep.increaseNumberOfSteps();
                        }

                        if (action.payload.loggedUser.canEdit(resources.SETUP_ENVIRONMENT_IMPORT)) {
                            settingsStep.increaseNumberOfSteps();
                        }

                        return settingsStep;
                    } else {
                        return step.updateAvailable(false);
                    }
                }

                if (step.name === setup.SUMMARY) {
                    if (removeVisited) {
                        return step.updateVisited(false).updateCompleted();
                    }

                    return step.updateCompleted();
                }

                return step;
            });

            return {
                active: getterHelper.getObjectByName(updatedSettingsSteps, state.active.name),
                steps: updatedSettingsSteps
            };
        case actionTypes.WEBSOCKET_CLOSED:
            if (state.active.name !== setup.DATABASE) {
                return initialState;
            }

            return {
                ...initialState,
                active: state.active
            };
        case actionTypes.SETUP_SET_STEP:
            let selectedSetupStep = null;

            let item;
            for (item of state.steps) {
                if (item.index === action.payload.step && item.available) {
                    selectedSetupStep = item;
                }
            }

            if (selectedSetupStep === null) {
                return state;
            }

            if (selectedSetupStep.visited) {
                return {
                    ...state,
                    active: selectedSetupStep
                };
            }

            let updatedNextSteps = state.steps.map((step) => {
                if (step.index === selectedSetupStep.index) {
                    return step.updateVisited(true);
                }

                return step;
            });

            return {
                ...state,
                active: selectedSetupStep.updateVisited(true),
                steps: updatedNextSteps
            };
        default:
            return state;
    }
};
